import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES
} from 'shared/constants';

const propsSchema = [
  {
    key: 'section_tag',
    label: 'Section Tag',
    type: types.TEXT
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'description',
    label: 'Description',
    type: types.TEXT
  },
  {
    key: 'bg_color',
    label: 'Background Color',
    type: types.COLOR_PICKER
  },
  {
    key: 'theme',
    label: 'Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
];

const defaultProps = {
  section_tag: 'designSection',
  title: 'Design',
  description: 'The Making of an Advanced Design Culture',
  bg_color: '#141618',
  theme: 'DARK',
};

export default {
  title: 'Non-Descriptive Intro',
  id: 'NonDescriptiveIntro',
  propsSchema,
  defaultProps
};
